import {
  PATIENT_CONSULTATION_STATUS,
  PatientConsultationStatus,
} from "~/common/constants/consultation";

export const isConsultationCompleted = (
  patientConsultationStatus?: PatientConsultationStatus,
) => patientConsultationStatus === PATIENT_CONSULTATION_STATUS.completed;
